import { render, staticRenderFns } from "./HazardList.vue?vue&type=template&id=73331b52&scoped=true&"
import script from "./HazardList.vue?vue&type=script&lang=js&"
export * from "./HazardList.vue?vue&type=script&lang=js&"
import style0 from "./HazardList.vue?vue&type=style&index=0&id=73331b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73331b52",
  null
  
)

export default component.exports